/* tslint:disable */
/* eslint-disable */
/**
 * Web MMB BFF API
 * Version of Backend for Frontend API (mid-layer between FE and MMB API) designed for web frontend purposes.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const OriginalSectorVehicleTypesValueEnum = {
    Train: 'train',
    Bus: 'bus',
    Airplane: 'airplane'
};
/**
 * Check if a given object implements the OriginalSectorVehicleTypes interface.
 */
export function instanceOfOriginalSectorVehicleTypes(value) {
    return true;
}
export function OriginalSectorVehicleTypesFromJSON(json) {
    return OriginalSectorVehicleTypesFromJSONTyped(json, false);
}
export function OriginalSectorVehicleTypesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'value': json['value'] == null ? undefined : json['value'],
    };
}
export function OriginalSectorVehicleTypesToJSON(json) {
    return OriginalSectorVehicleTypesToJSONTyped(json, false);
}
export function OriginalSectorVehicleTypesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'value': value['value'],
    };
}
